import createRequestBody from '../../utils/createRequestBody';

const queryTweets = async(url, token) => {
    
    let body = createRequestBody('GET', token);

    return fetch(url, body);

}

export default queryTweets;